import { Controller } from '@hotwired/stimulus'
import { fetchSystemStatus } from '../javascript/systems'

export default class extends Controller {
  static values = {
    model: String,
    identifier: String,
    refetchOnMount: Boolean,
  }
  static targets = ['loader', 'lastFetched']
  static classes = ['loading']

  TIMEOUT = 30000

  oldLastFetched
  disabled = false

  refresh(e) {
    e.preventDefault()

    e.stopPropagation()

    if (this.disabled) return

    this.disabled = true

    this.toggleUI()

    fetchSystemStatus(this.modelValue, this.identifierValue)
      .then(() => {
        if (typeof this.oldLastFetched !== 'undefined') {
          this.lastFetchedTarget.innerHTML = this.oldLastFetched
        } else {
          this.oldLastFetched = this.lastFetchedTarget.innerHTML
        }

        setTimeout(() => {
          this.toggleUI()
          this.lastFetchedTarget.innerText = `No response in ${this.TIMEOUT / 1000} seconds`
          delete this.lastFetchedTarget.dataset['timeFormatTarget']
          this.disabled = false
        }, this.TIMEOUT)
      })
      .catch(() => {
        this.toggleUI()
        this.lastFetchedTarget.innerText = 'Error fetching status'
        delete this.lastFetchedTarget.dataset['timeFormatTarget']
        this.disabled = false
      })
  }

  toggleUI() {
    if (this.loadingClass) this.loaderTarget.classList.toggle(this.loadingClass)
  }
}
